<template>
  <div class="page-header">
    <h1>{{ pageTitle }}</h1>
    <hr v-if="!hideDivision" />
  </div>
</template>

<script>
export default {
  name: "TrfHeader",
  props: {
    pageTitle: {
      type: String,
      default: 'eTarefas'
    },
    hideDivision: {
      type: Boolean,
      default: false
    }
  },
};
</script>

<style lang="scss" scoped>
hr {
  width: 100%;
}
.page-header {
  margin: 0;
  h1 {
    font-size: 36px;
  }
}
</style>
